import AppCard from '@crema/core/AppCard';
import AppList from '@crema/core/AppList';
import jwtAxios from '@crema/services/auth/jwt-auth';
import {useAuthUser} from '@crema/utility/AuthHooks';
import {ArrowBack, Info} from '@mui/icons-material';
import AppConfirmDialog from '@crema/core/AppConfirmDialog';

import {
  Box,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import {grey, red} from '@mui/material/colors';
import moment from 'moment';
import {useCallback, useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {
  onAddAttachmentDigisign,
  onAddAttachmentDigisignSK,
  onAddDocumentDigisign,
  onChangeFilter,
  onDeleteAttachmentDigisign,
  onGetDetailDraftDigisign,
  onGetDokumenPKPYB,
  onPutDocumentDigisign,
} from 'redux/actions/DigitalSign';
import AddressBookItem from 'shared/components/Addressbook/AddressBookItem';
import AddressBookWrapper from 'shared/components/Addressbook/AddressBookWrapper';
import Addressbook from 'shared/components/Addressbook/Addressbook';
import {ButtonContained, ButtonOutlined} from 'shared/components/Button';
import {FETCH_ERROR} from 'shared/constants/ActionTypes';
import {COLORS} from 'shared/constants/AppEnums';
import useModal from 'shared/hooks/useModal';
import FileRow from './FileRow';
import PetunjukDialog from './PetunjukDialog';
import UploadModern from './UploadModern';

const TambahDokumen = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [modalConfSubmit, setModalConfSubmit] = useState(false);
  const [modalConfSave, setModalConfSave] = useState(false);

  const {optionPYBPK} = useSelector((s) => s.digiSign);
  const [index, setIndex] = useState(-1);
  const {user} = useAuthUser();
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [isUploadDokumen, setIsUploadDokumen] = useState(false);
  const [dataDokumen, setDataDokumen] = useState({
    judul: '',
    noSertif: '',
    jenis: '',
    jenisSk: '',
    tglSurat: moment().format('YYYY-MM-DD'),
    tugas: '',
    status: '',
    penanda: '',
    displayApproval: [],
    pilihanApproval: [],
    penerimaCode: [],
    displayPenerima: [],
    pilihanPenerima: [],
    tembusanCode: [],
    displayTembusan: [],
    pilihanTembusan: [],
    keterangan: '',
    formError: {
      judul: '',
      errorJudul: false,
      noSertif: '',
      errorNoSertif: false,
      tglSurat: '',
      errorTglSurat: false,
      tugas: '',
      errorTugas: false,
      status: '',
      errorStatus: false,
      jenis: '',
      errorJenis: false,
      penanda: '',
      errorPenanda: false,
      penerima: '',
      errorPenerima: false,
      errorTembusan: false,

      attachment: '',
      errorAttachment: false,
      keterangan: '',
      errorKeterangan: false,
      approval: '',
      errorApproval: false,
    },
  });
  const [countUploadDokumen, setCountUploadDokumen] = useState(0);

  useEffect(() => {
    dispatch(onGetDokumenPKPYB());
  }, []);

  const [openAddressbook, setOpenAddressbook] = useState({
    id: '',
    toggle: false,
  });
  const {id} = useParams();
  const [isDisabled, setIsDisabled] = useState(id === undefined ? false : true);
  const [pilihanPenanda, setpilihanPenanda] = useState([]);
  const [openPetunjuk, setOpenPetunjuk] = useState(false);
  const {attachment, detail} = useSelector((state) => state.digiSign);
  const {pathname} = useLocation();

  useEffect(() => {
    if (optionPYBPK.length > 0) {
      const allowedNames = [
        'MENTERI KELAUTAN DAN PERIKANAN',
        'SEKRETARIS JENDERAL',
      ];
      const filtered = allowedNames
        .map((name) => optionPYBPK.find((x) => x.name?.toUpperCase() === name))
        .filter(Boolean);
      setpilihanPenanda(filtered);
    }
  }, [optionPYBPK]);

  // const { loading } = useSelector(state => state.common)
  const [config, setConfig] = useState({});
  const {stateAddress, toggleShow, toggleHide, setPayloadOnHide} = useModal();

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    setIsUploadDokumen(false);
    if (fileRejections.length !== 0 && acceptedFiles.length === 0) {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Tipe File Tidak Mendukung',
      });
    } else {
      setUploadedFiles(null);
      setCountUploadDokumen(0);
      dispatch(onDeleteAttachmentDigisign());
      const size = (acceptedFiles[0].size / 1024 / 1024).toFixed(3);
      if (size <= 50) {
        console.log(acceptedFiles);
        dispatch(onAddAttachmentDigisignSK('PK', acceptedFiles[0]));
        setUploadedFiles({
          name: 'PK_' + acceptedFiles[0].name,
          type: acceptedFiles[0].type,
          size: acceptedFiles[0].size,
          file: acceptedFiles[0],
        });
      } else {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Ukuran File Maksimal 50 MB',
        });
      }
    }
  }, []);

  useEffect(() => {
    if (
      id !== undefined &&
      pathname === '/apps/dokumen-pk/tambah-dokumen/' + id
    ) {
      setUploadedFiles(null);
      dispatch(onDeleteAttachmentDigisign());
      dispatch(onGetDetailDraftDigisign(id));
    }
  }, [id]);

  useEffect(() => {
    if (
      detail !== null &&
      id !== undefined &&
      pathname === '/apps/dokumen-pk/tambah-dokumen/' + id
    ) {
      const dataDisplayPenerima = [];
      const dataCodePenerima = [];
      const dataPilihanPenerima = [];

      detail.receivers?.map((item, index) => {
        dataDisplayPenerima.push(
          item.is_title ? item.display_title : item.nama,
        );
        dataCodePenerima.push(item.is_title ? item.objidposisi : item.nip);
        dataPilihanPenerima.push({
          id: item.is_title ? item.objidposisi : item.nip,
          code: item.is_title ? item.objidposisi : item.nip,
          text: item.is_title ? item.display_title : item.nama,
          nip: item.is_title ? item.officer.nip : item.nip,
          title: item.is_title ? item.display_title : item.nama,
          name: item.is_title ? item.display_title : item.nama,
        });
      });

      const dataDisplayTembusan = [];
      const dataCodeTembusan = [];
      const dataPilihanTembusan = [];

      detail.tembusans?.map((item, index) => {
        dataDisplayTembusan.push(
          item.is_title ? item.display_title : item.nama,
        );
        dataCodeTembusan.push(item.is_title ? item.objidposisi : item.nip);
        dataPilihanTembusan.push({
          id: item.is_title ? item.objidposisi : item.nip,
          code: item.is_title ? item.objidposisi : item.nip,
          text: item.is_title ? item.display_title : item.nama,
          nip: item.is_title ? item.officer.nip : item.nip,
          title: item.is_title ? item.display_title : item.nama,
          name: item.is_title ? item.display_title : item.nama,
        });
      });

      console.log('dataPilihanPenerima', dataPilihanPenerima);
      console.log('displa', dataDisplayPenerima);

      const approversRemaining = [...(detail.approvers || [])];
      const penandaApprover = approversRemaining.pop();

      setDataDokumen({
        ...dataDokumen,
        judul: detail.subject,
        noSertif: detail.extra_attributes?.noDokumen,
        jenis: detail.extra_attributes?.tipeDokumen?.toUpperCase(),
        jenisSk: detail.extra_attributes?.jenisDokumen,
        tglSurat: moment(detail.extra_attributes?.tanggalDokumen).format(
          'YYYY-MM-DD',
        ),
        displayApproval: [],
        penanda: penandaApprover?.is_title
          ? penandaApprover?.officer?.nip
          : penandaApprover?.nip,
        displayPenerima: dataPilihanPenerima,
        penerimaCode: dataCodePenerima,
        tembusanCode: dataCodeTembusan,
        displayTembusan: dataPilihanTembusan,
        pilihanTembusan: dataPilihanTembusan,
        pilihanPenerima: dataPilihanPenerima,
        status: detail.extra_attributes?.status,
        tugas: detail.extra_attributes?.tugas,
        keterangan: detail.extra_attributes?.keterangan,
        formError: {
          judul: '',
          errorJudul: false,
          noSertif: '',
          errorNoSertif: false,
          jenis: '',
          errorJenis: false,
          penanda: '',
          errorPenanda: false,
          attachment: '',
          errorAttachment: false,
          keterangan: '',
          errorKeterangan: false,
          penerima: '',
          errorPenerima: false,
        },
      });

      if (detail.attachments?.length) {
        const lastAttachment =
          detail.attachments[detail.attachments.length - 1];
        setUploadedFiles({
          name: lastAttachment.name,
          type: getFileExtension(lastAttachment.name),
          size: lastAttachment.file_size,
        });
        detail.attachments.forEach((item) => {
          dispatch(onAddAttachmentDigisign('', {...item}));
        });
      }
    }
  }, [detail]);

  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  useEffect(() => {
    if (!stateAddress.isClose && !stateAddress.show) {
      const processPayload = (payload, type) => {
        let code = [];
        let display = [];
        let nipList = [];

        payload.forEach((item) => {
          const nip =
            item.nip ||
            item.oriItem?.nip ||
            item.oriItem?.officer?.official?.split('/')[1];
          const name =
            item.oriItem?.officer?.official?.split('/')[0] ||
            item.text.split('/')[0];
          const title = item.oriItem?.title || item.title || '';

          code.push(nip);
          display.push({title, name, nama: name});
        });

        return {code, display, nipList};
      };

      const {judul} = config;
      const {payload} = stateAddress;

      if (judul === 'Penerima') {
        const {code, display} = processPayload(payload, 'Penerima');
        setDataDokumen({
          ...dataDokumen,
          displayPenerima: display,
          penerimaCode: code,
          pilihanPenerima: [...payload],
        });
      } else if (judul === 'Tembusan') {
        const {code, display} = processPayload(payload, 'Tembusan');

        setDataDokumen({
          ...dataDokumen,
          displayTembusan: display,
          tembusanCode: code,
          pilihanTembusan: [...payload],
        });
      }
    }
  }, [stateAddress, config]);

  useEffect(() => {
    const isEditDraftRoute =
      id !== undefined && pathname === '/apps/dokumen-pk/tambah-dokumen/' + id;

    if (!isEditDraftRoute) {
      handleResetDocument();
    }
  }, [pathname]);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/': ['.pdf'],
    },
  });

  const onDeleteUploadFile = (file) => {
    // const data = uploadedFiles
    // const index = data.indexOf(file)
    // data.splice(index, 1)
    setUploadedFiles(null);
    setCountUploadDokumen(0);

    // const dataResponseAttachment = documentAttachment
    // const dataDeleted = dataResponseAttachment.at(index)

    // dataResponseAttachment.splice(index, 1)
    dispatch(onDeleteAttachmentDigisign());
  };

  const onDeleteAddressBook = (item, title) => {
    const mappings = {
      Penerima: {
        displayKey: 'displayPenerima',
        pilihanKey: 'pilihanPenerima',
        codeKey: 'penerimaCode',
      },
      // Add other title mappings here

      Tembusan: {
        displayKey: 'displayTembusan',
        pilihanKey: 'pilihanTembusan',
        codeKey: 'tembusanCode',
      },
      // Continue for other titles
    };

    const mapping = mappings[title];
    if (!mapping) {
      console.error(`Unhandled title: ${title}`);
      return;
    }

    const dataDisplay = [...dataDokumen[mapping.displayKey]];
    const dataPilihan = [...dataDokumen[mapping.pilihanKey]];
    const dataCode = [...dataDokumen[mapping.codeKey]];
    const dataNip = mapping.nipKey ? [...dataDokumen[mapping.nipKey]] : null;

    const index = dataDisplay.indexOf(item);
    if (index > -1) {
      dataDisplay.splice(index, 1);
      dataPilihan.splice(index, 1);
      dataCode.splice(index, 1);
      if (dataNip) dataNip.splice(index, 1);
    }

    setDataDokumen({
      ...dataDokumen,
      [mapping.displayKey]: dataDisplay,
      [mapping.pilihanKey]: dataPilihan,
      [mapping.codeKey]: dataCode,
      ...(dataNip && {[mapping.nipKey]: dataNip}),
    });
  };

  const handleInputDocument = (name, value) => {
    setDataDokumen({
      ...dataDokumen,
      [name]: value,
    });
  };

  const computeApproval = (value) => {
    if (!value || optionPYBPK.length === 0) return;
    const upper = (s) => s?.toUpperCase();
    const wakilMenteri = optionPYBPK.find((x) =>
      upper(x.name)?.includes('WAKIL MENTERI'),
    );
    const sekjen = optionPYBPK.find(
      (x) => upper(x.name) === 'SEKRETARIS JENDERAL',
    );
    const kepalaBiro = optionPYBPK.find((x) =>
      upper(x.name)?.includes('KEPALA BIRO'),
    );
    const ketuaTim = optionPYBPK.find((x) =>
      upper(x.name)?.includes('KETUA TIM'),
    );
    const extra = optionPYBPK[optionPYBPK.length - 1];

    const selected = optionPYBPK.find((x) => x.origin?.nik === value);
    let arr = [];
    if (upper(selected?.name) === 'MENTERI KELAUTAN DAN PERIKANAN') {
      arr = [ketuaTim, kepalaBiro, sekjen, wakilMenteri].filter(Boolean);
    } else if (upper(selected?.name) === 'SEKRETARIS JENDERAL') {
      arr = [ketuaTim, kepalaBiro].filter(Boolean);
    }

    if (extra) {
      arr = [extra, ...arr];
    }

    setDataDokumen((prev) => ({
      ...prev,
      penanda: value,
      displayApproval: arr,
    }));
  };

  const handleOnChangePenanda = (name, value) => {
    computeApproval(value);
  };

  useEffect(() => {
    if (
      dataDokumen.penanda !== '' &&
      optionPYBPK.length > 0 &&
      dataDokumen.displayApproval.length === 0
    ) {
      computeApproval(dataDokumen.penanda);
    }
  }, [optionPYBPK, dataDokumen.penanda]);

  const handleValidationInput = (isDraft = false) => {
    let judul = '';
    let errorJudul = false;
    let noSertif = '';
    let errorNoSertif = false;
    let jenis = '';
    let errorJenis = false;
    let penanda = '';
    let errorPenanda = false;
    let lampiran = '';
    let errorLampiran = false;
    let keterangan = '';
    let errorKeterangan = false;
    let penerima = '';
    let errorPenerima = false;
    let tugas = '';
    let errorTugas = false;
    let tglSurat = '';
    let errorTglSurat = false;
    let status = '';
    let errorStatus = false;

    if (dataDokumen.judul === '') {
      judul = 'Judul Wajib diisi';
      errorJudul = true;
    } else {
      judul = '';
      errorJudul = false;
    }

    if (!isDraft) {
      if (dataDokumen.noSertif === '') {
        noSertif = 'No Sertif Wajib diisi';
        errorNoSertif = true;
      } else {
        noSertif = '';
        errorNoSertif = false;
      }

      if (dataDokumen.jenis === '') {
        jenis = 'Jenis Dokumen Wajib diisi';
        errorJenis = true;
      } else {
        jenis = '';
        errorJenis = false;
      }

      if (dataDokumen.penanda === '') {
        errorPenanda = true;
        penanda = 'Penandatangan Dokumen Wajib Diisi';
      } else {
        errorPenanda = false;
        penanda = '';
      }

      if (attachment.length === 0 || countUploadDokumen === 0) {
        errorLampiran = true;
        lampiran = 'Harap upload Dokumen Terlebih Dahulu';
      } else {
        errorLampiran = false;
        lampiran = '';
      }

      if (dataDokumen.penerimaCode.length === 0) {
        errorPenerima = true;
        penerima = 'Penerima Wajib Dipilih';
      } else {
        errorPenerima = false;
        penerima = '';
      }

      if (dataDokumen.tugas === '') {
        errorTugas = true;
        tugas = 'Tugas Wajib diisi';
      } else {
        errorTugas = false;
        tugas = '';
      }

      if (dataDokumen.tglSurat === '') {
        errorTglSurat = true;
        tglSurat = 'Tanggal Wajib diisi';
      } else {
        errorTglSurat = false;
        tglSurat = '';
      }

      if (dataDokumen.status === '') {
        errorStatus = true;
        status = 'Status Wajib Dipilih';
      } else {
        errorStatus = false;
        status = '';
      }
    }

    setDataDokumen({
      ...dataDokumen,
      formError: {
        judul: judul,
        errorJudul: errorJudul,
        noSertif: noSertif,
        errorNoSertif: errorNoSertif,
        tugas: tugas,
        errorTugas: errorTugas,
        tglSurat: tglSurat,
        errorTglSurat: errorTglSurat,
        status: status,
        errorStatus: errorStatus,
        jenis: jenis,
        errorJenis: errorJenis,
        penanda: penanda,
        errorPenanda: errorPenanda,
        attachment: lampiran,
        errorAttachment: errorLampiran,
        keterangan: keterangan,
        errorKeterangan: errorKeterangan,
        penerima: penerima,
        errorPenerima: errorPenerima,
      },
    });
  };

  const handleSubmitDokumen = (action) => {
    const isDraft = action === 'draft';
    const isInvalid = isDraft
      ? dataDokumen.judul === ''
      : dataDokumen.judul === '' ||
        dataDokumen.noSertif === '' ||
        dataDokumen.tugas === '' ||
        dataDokumen.tglSurat === '' ||
        dataDokumen.status === '' ||
        dataDokumen.penanda === '' ||
        dataDokumen.penerimaCode.length === 0 ||
        attachment.length === 0 ||
        countUploadDokumen === 0;

    if (isInvalid) {
      handleValidationInput(isDraft);
      dispatch({
        type: FETCH_ERROR,
        payload: 'Mohon Masukan Data Dokumen Dengan Benar',
      });
    } else {
      const checkLabel = isDraft ? true : checkLabelExist();

      if (!checkLabel) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Mohon Masukan Label',
        });
      } else {
        const arrApproval = [
          ...dataDokumen.displayApproval.map((x) => x.origin?.nik),
          dataDokumen.penanda,
        ].filter(Boolean);

        const data = {
          subject: dataDokumen.judul,
          approvers: arrApproval,
          tembusans: dataDokumen.tembusanCode,
          receivers: dataDokumen.penerimaCode,
          id_attachments: [],
          action: action,
          tipe_dokumen: 'dokumen_pk',
          extra_attributes: {
            noDokumen: dataDokumen.noSertif,
            keterangan: dataDokumen.keterangan,
            status: dataDokumen.status,
            tugas: dataDokumen.tugas,
            tanggalDokumen: new Date(dataDokumen.tglSurat).toISOString(),
          },
          comment: 'comment',
          app: 'Dokumen PK',
          base_url: '/apps/dokumen-pk/detail/$id?filter=pk-need-sign',
          message: 'Dokumen perlu disetujui',
        };

        attachment.map((item) => {
          data.id_attachments.push(item.id);
        });

        if (id !== undefined) {
          dispatch(onPutDocumentDigisign(data, id));
          if (action === 'submit') {
            dispatch(onChangeFilter('composer'));
          } else if (action === 'draft') {
            dispatch(onChangeFilter('draft'));
          }
        } else {
          dispatch(onAddDocumentDigisign(data, 'dokumen_pk'));
          if (action === 'submit') {
            dispatch(onChangeFilter('composer'));
          } else {
            dispatch(onChangeFilter('draft'));
          }
        }

        setTimeout(() => {
          handleNavigation(`/apps/dokumen-pk`);
        }, 3000);
      }
    }
  };

  const handleCancelDocument = () => {
    handleNavigation(-1);
    handleResetDocument();
  };

  const handleResetDocument = () => {
    setDataDokumen({
      judul: '',
      noSertif: '',
      jenis: '',
      tugas: '',
      status: '',
      penanda: '',
      displayApproval: [],
      penandaCode: [],
      displayPenanda: [],
      pilihanPenanda: [],
      penandaNip: [],
      tglSurat: moment().format('YYYY-MM-DD'),
      keterangan: '',
      tembusanCode: [],
      displayTembusan: [],
      pilihanTembusan: [],
      displayPenerima: [],
      penerimaCode: [],
      pilihanPenerima: [],
      formError: {
        judul: '',
        errorJudul: false,
        noSertif: '',
        errorNoSertif: false,
        tugas: '',
        errorTugas: false,
        tglSurat: '',
        errorTglSurat: false,
        status: '',
        errorStatus: false,
        jenis: '',
        errorJenis: false,
        penanda: '',
        errorPenanda: false,
        attachment: '',
        errorAttachment: false,
        keterangan: '',
        errorKeterangan: false,
        penerima: '',
        errorPenerima: false,
      },
    });
    setUploadedFiles(null);
    setIsUploadDokumen(false);
    setCountUploadDokumen(0);
    dispatch(onDeleteAttachmentDigisign());
  };

  const handleToggleAddressBook = (title) => {
    let payloadPilihan;
    if (title === 'Penerima') {
      payloadPilihan = dataDokumen.pilihanPenerima
        ? [...dataDokumen.pilihanPenerima]
        : [];
    } else if (title === 'Tembusan')
      payloadPilihan = dataDokumen.pilihanTembusan
        ? [...dataDokumen.pilihanTembusan]
        : [];

    setConfig((config) => ({
      ...config,
      judul: title,
      tabs: {
        jabatan: title === 'Penerima' ? false : true,
        pegawai: true,
        personal: false,
        klasifikasi: false,
      },
      multiselect: title === 'Tembusan',
      payloadPilihan: payloadPilihan,
    }));
    toggleShow();
  };

  const handleNavigation = (to) => {
    handleResetDocument();
    navigation(to);
  };

  const handleCountUploadDokumen = () => {
    setCountUploadDokumen((prev) => prev + 1);
  };

  const handleUploadDokumen = async () => {
    const checkLabel = checkLabelExist();
    if (checkLabel) {
      setIsUploadDokumen(true);
      const iframe = document.querySelector('#iframeDokLain');
      const datapdf =
        await iframe?.contentWindow?.PDFViewerApplication?.getPDFBlob();
      const blob = new Blob([datapdf], {
        type: 'application/pdf',
      });
      var file = new File([blob], uploadedFiles.name, {
        type: uploadedFiles.type,
        path: uploadedFiles.name,
      });
      console.log('testing', URL.createObjectURL(file));
      dispatch(onAddAttachmentDigisignSK('PK', file, handleCountUploadDokumen));
    } else {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Mohon Masukan Label',
      });
    }
  };

  const checkLabelExist = () => {
    const iframe = document.querySelector('#iframeDokLain');
    return iframe?.contentWindow?.PDFViewerApplication._hasAnnotationEditors;
  };

  const getLabelSign = (url) => {
    jwtAxios
      .get(url, {responseType: 'blob'})
      .then((data) => {
        window.sign_file_blob = data.data;
      })
      .catch((error) => {
        console.debug('error ', error);
      });
  };

  const openPDF = (data) => {
    const iframe = document.querySelector('#iframeDokLain');
    const wrapper = document.querySelector('#wrapperIframeTambah');
    if (iframe) {
      wrapper.appendChild(iframe);

      const applyStylesAndOpen = () => {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;

        // Inject custom styles into the iframe
        const style = iframeDoc.createElement('style');
        style.textContent = `
                    #editorModeButtons #editorFreeText,
                    #editorModeButtons #editorInk {
                        display: none !important; /* Hide specific annotations */
                    }
                `;
        iframeDoc.head.appendChild(style);

        // Open the PDF file in the viewer
        iframe.contentWindow?.PDFViewerApplication.open(data);
      };

      if (iframe.contentWindow?.PDFViewerApplication?.initialized) {
        applyStylesAndOpen();
      } else {
        iframe.onload = applyStylesAndOpen;
      }
    }
  };

  useEffect(() => {
    if (attachment.length !== 0 && !isUploadDokumen) {
      openPDF(attachment[attachment.length - 1].file);
      let labelSign =
        window.location.protocol +
        '//' +
        window.location.host +
        '/assets/images/Tandatangan.png';
      getLabelSign(labelSign);
    }
  }, [attachment]);

  useEffect(() => {
    console.log(dataDokumen.penanda);
  }, [dataDokumen.penanda]);

  return (
    <>
        <Stack direction='column' spacing={4} height={'100% !important'}>
          <AppCard
            sxStyle={{
              backgroundColor: 'white !important',
              height: '100% !important',
            }}
          >
            <Stack
              sx={{
                '& label.Mui-focused': {
                  color: COLORS.primary,
                },
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: grey[500],
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: COLORS.primary,
                    color: COLORS.primary,
                  },
                },
              }}
              spacing={2}
              height={'100% !important'}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <Tooltip title={'Kembali'} placement='top' arrow>
                    <IconButton onClick={handleCancelDocument}>
                      <ArrowBack />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Stack direction='row' spacing={2}>
                  <ButtonOutlined
                    variant='text'
                    startIcon={<Info />}
                    onClick={() => setOpenPetunjuk(true)}
                  >
                    Petunjuk
                  </ButtonOutlined>
                  <ButtonOutlined
                    variant='outlined'
                    onClick={handleCancelDocument}
                  >
                    Batal
                  </ButtonOutlined>
                  {id !== undefined &&
                    (isDisabled ? (
                      <ButtonContained
                        variant='contained'
                        onClick={() => setIsDisabled(false)}
                      >
                        Edit
                      </ButtonContained>
                    ) : (
                      <ButtonContained
                        variant='contained'
                        onClick={() => setIsDisabled(true)}
                      >
                        Undo
                      </ButtonContained>
                    ))}
                  <ButtonContained
                    variant='contained'
                    sx={{
                      '&:hover': {background: '#a58b67 !important'},
                      background: '#d2b48c !important',
                    }}
                    onClick={() => setModalConfSave(true)}
                  >
                    Simpan Draft
                  </ButtonContained>
                  <ButtonContained
                    variant='contained'
                    onClick={() => setModalConfSubmit(true)}
                  >
                    Kirim
                  </ButtonContained>
                </Stack>
              </Box>

              <Divider />
              <Grid container columnSpacing={4} rowGap={5}>
                {(detail || id === undefined) && (
                  <>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={1}>
                        <InputLabel htmlFor='judul' sx={{fontWeight: 600}}>
                          Judul PK<span style={{color: 'red'}}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          name='judul'
                          placeholder='Masukan Judul PK'
                          variant='outlined'
                          disabled={isDisabled}
                          value={dataDokumen.judul}
                          error={dataDokumen.formError.errorJudul}
                          onChange={(e) =>
                            handleInputDocument(e.target.name, e.target.value)
                          }
                        />
                        {dataDokumen.formError.errorJudul ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.judul}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={1}>
                        <InputLabel htmlFor='tugas' sx={{fontWeight: 600}}>
                          JABATAN PPPK<span style={{color: 'red'}}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          name='tugas'
                          disabled={isDisabled}
                          placeholder='Masukan Jabatan PK'
                          variant='outlined'
                          value={dataDokumen.tugas}
                          error={dataDokumen.formError.errorTugas}
                          onChange={(e) =>
                            handleInputDocument(e.target.name, e.target.value)
                          }
                        />
                        {dataDokumen.formError.errorTugas ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.tugas}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={1}>
                        <InputLabel htmlFor='noSertif' sx={{fontWeight: 600}}>
                          Nomor PK<span style={{color: 'red'}}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          name='noSertif'
                          placeholder='Masukan Nomor PK'
                          variant='outlined'
                          disabled={isDisabled}
                          value={dataDokumen.noSertif}
                          error={dataDokumen.formError.errorNoSertif}
                          onChange={(e) =>
                            handleInputDocument(e.target.name, e.target.value)
                          }
                        />
                        {dataDokumen.formError.errorNoSertif ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.noSertif}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={1}>
                        <InputLabel htmlFor='status' sx={{fontWeight: 600}}>
                          STATUS<span style={{color: 'red'}}>*</span>
                        </InputLabel>
                        <FormControl sx={{m: 1, minWidth: 120}}>
                          <Select
                            name='status'
                            variant='outlined'
                            labelId='dropdown'
                            id='status'
                            fullWidth
                            disabled={isDisabled}
                            error={dataDokumen.formError.errorStatus}
                            value={dataDokumen.status}
                            onChange={(e) =>
                              handleInputDocument(e.target.name, e.target.value)
                            }
                          >
                            <MenuItem value={'PPPK Paruh Waktu'}>
                              PPPK Paruh Waktu
                            </MenuItem>
                            <MenuItem value={'PPPK'}>PPPK</MenuItem>
                          </Select>
                        </FormControl>
                        {dataDokumen.formError.errorStatus ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.status}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Stack spacing={1}>
                        <InputLabel
                          htmlFor='penerima'
                          onClick={() => handleToggleAddressBook('Penerima')}
                          sx={{fontWeight: 600}}
                        >
                          PENANDATANGAN PIHAK KEDUA<span style={{color: 'red'}}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={isDisabled}
                          name='penerima'
                          onClick={() => handleToggleAddressBook('Penerima')}
                          variant='outlined'
                          error={dataDokumen.formError.errorPenerima}
                          value={dataDokumen.displayPenerima[0]?.name}
                        />
                        {dataDokumen.formError.errorPenerima ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.penerima}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack spacing={1}>
                        <InputLabel htmlFor='tglSurat' sx={{fontWeight: 600}}>
                          Tanggal PK<span style={{color: 'red'}}>*</span>
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={isDisabled}
                          type='date'
                          name='tglSurat'
                          placeholder='Masukan Tanggal Surat PK'
                          variant='outlined'
                          value={dataDokumen.tglSurat}
                          error={dataDokumen.formError.errorTglSurat}
                          onChange={(e) =>
                            handleInputDocument(e.target.name, e.target.value)
                          }
                        />
                        {dataDokumen.formError.errorTglSurat ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.tglSurat}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Grid item xs={12} md={12}>
                        <Stack spacing={1}>
                          <InputLabel htmlFor='penanda' sx={{fontWeight: 600}}>
                            PENANDATANGAN PIHAK KESATU<span style={{color: 'red'}}>*</span>
                          </InputLabel>
                          <FormControl sx={{m: 1, minWidth: 120}}>
                            <Select
                              name='penanda'
                              variant='outlined'
                              labelId='dropdown'
                              id='penanda'
                              fullWidth
                              disabled={isDisabled}
                              error={dataDokumen.formError.errorPenanda}
                              value={dataDokumen.penanda}
                              onChange={(e) =>
                                handleOnChangePenanda(
                                  e.target.name,
                                  e.target.value,
                                )
                              }
                            >
                              {pilihanPenanda.map((x, index) => (
                                <MenuItem key={index} value={x.origin?.nik}>
                                  {x.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {dataDokumen.formError.errorPenanda ? (
                            <Typography variant='caption' color={red[500]}>
                              {dataDokumen.formError.penanda}
                            </Typography>
                          ) : null}
                        </Stack>
                      </Grid>
                      <Stack spacing={1}>
                        <Box className='p-3'>
                          <InputLabel sx={{fontWeight: 600, cursor: 'pointer'}}>
                            Approval<span style={{color: 'red'}}>*</span>
                          </InputLabel>
                          <AppList
                            data={dataDokumen.displayApproval}
                            renderRow={(item, index) => (
                              <AddressBookItem item={item.name} index={index} />
                            )}
                          />
                        </Box>

                        {dataDokumen.displayApproval?.length > 5 ? (
                          <Stack direction='row' justifyContent={'flex-end'}>
                            <Typography
                              variant='body1'
                              color={COLORS.primary}
                              sx={{cursor: 'pointer'}}
                              onClick={() =>
                                setOpenAddressbook({
                                  toggle: true,
                                  id: 'Approval',
                                })
                              }
                            >
                              Lihat Selengkapnya
                            </Typography>
                          </Stack>
                        ) : null}
                      </Stack>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Stack spacing={1}>
                        <InputLabel
                          onClick={() => handleToggleAddressBook('Tembusan')}
                          sx={{fontWeight: 600, cursor: 'pointer'}}
                        >
                          Tembusan
                        </InputLabel>

                        <TextField
                          fullWidth
                          disabled={isDisabled}
                          placeholder='Pilih dari Addressbook'
                          variant='outlined'
                          error={dataDokumen.formError.errorTembusan}
                          onClick={() => handleToggleAddressBook('Tembusan')}
                        />

                        <AppList
                          data={dataDokumen.displayTembusan.slice(0, 4)}
                          renderRow={(item, index) => (
                            <AddressBookItem
                              item={item}
                              onDeleteAddressBook={() =>
                                onDeleteAddressBook(item, 'Tembusan')
                              }
                              labelDelete='Hapus Tembusan'
                              index={index}
                              jabatan={true}
                            />
                          )}
                        />
                        {dataDokumen.displayTembusan.length > 5 ? (
                          <Stack direction='row' justifyContent={'flex-end'}>
                            <Typography
                              variant='body1'
                              color={COLORS.primary}
                              sx={{cursor: 'pointer'}}
                              onClick={() =>
                                setOpenAddressbook({
                                  toggle: true,
                                  id: 'Tembusan',
                                })
                              }
                            >
                              Lihat Selengkapnya
                            </Typography>
                          </Stack>
                        ) : null}
                      </Stack>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={12}>
                  <Stack spacing={1}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor='lampiran' sx={{fontWeight: 600}}>
                        Lampiran<span style={{color: 'red'}}>*</span>
                      </InputLabel>

                      {attachment.length !== 0 ? (
                        <FileRow
                          key={uploadedFiles.name}
                          file={uploadedFiles}
                          onDeleteUploadFile={onDeleteUploadFile}
                        />
                      ) : (
                        <UploadModern
                          uploadText='Seret dan jatuhkan unggah file sertifikat dalam format PDF file di sini, atau klik untuk memilih file'
                          getRootProps={getRootProps({className: 'dropzone'})}
                          getInputProps={getInputProps()}
                        />
                      )}
                    </Stack>

                    {attachment.length !== 0 && (
                      <Stack spacing={4} height={'100vh'}>
                        <Stack id={'wrapperIframeTambah'} flex={1}>
                          <iframe
                            src='/assets/latest-pdfjs-dist/web/viewer.html'
                            id='iframeDokLain'
                            style={{height: '100%', border: 0}}
                          />
                        </Stack>
                        <Stack direction={'row'} justifyContent={'end'}>
                          <Tooltip
                            arrow
                            placement='bottom'
                            title={'Upload dokumen PDF yang sudah ada label'}
                          >
                            <ButtonContained
                              variant='contained'
                              onClick={handleUploadDokumen}
                            >
                              Upload Dokumen
                            </ButtonContained>
                          </Tooltip>
                        </Stack>
                      </Stack>
                    )}

                    {dataDokumen.formError.errorAttachment ? (
                      <Typography variant='caption' color={red[500]}>
                        {dataDokumen.formError.attachment}
                      </Typography>
                    ) : null}
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </AppCard>
        </Stack>

      <AppConfirmDialog
        open={modalConfSubmit}
        onDeny={() => {
          setModalConfSubmit(false);
        }}
        onConfirm={() => {
          setModalConfSubmit(false);
          handleSubmitDokumen('submit');
        }}
        title={'Apakah anda yakin akan submit dokumen PK ini' + '?'}
        dialogTitle={'Submit PK'}
      />

      <AppConfirmDialog
        open={modalConfSave}
        onDeny={() => {
          setModalConfSave(false);
        }}
        onConfirm={() => {
          setModalConfSave(false);
          handleSubmitDokumen('draft');
        }}
        title={
          'Apakah anda yakin akan menyimpan dokumen PK ini sebagai draft' + '?'
        }
        dialogTitle={'Save PK as Draft'}
      />

      <Addressbook
        stateAddress={stateAddress}
        toggleHide={toggleHide}
        setPayloadOnHide={setPayloadOnHide}
        config={config}
      />
      <PetunjukDialog
        open={openPetunjuk}
        handleClose={() => setOpenPetunjuk(false)}
        action='tambah'
      />
      <AddressBookWrapper
        open={openAddressbook.toggle}
        handleClose={() => setOpenAddressbook({toggle: false, id: ''})}
        data={
          openAddressbook.id === 'Penerima'
            ? dataDokumen.displayPenerima
            : openAddressbook.id === 'Approval'
            ? dataDokumen.displayApproval.map((x) => x.name)
            : dataDokumen.displayTembusan
        }
        onDeleteAddressBook={
          openAddressbook.id === 'Approval' ? undefined : onDeleteAddressBook
        }
        multiple={true}
        id={openAddressbook.id}
        jabatan={openAddressbook.id !== 'Approval'}
        title='List Penandatangan'
        placeholderSearch='Cari Penandatangan'
      />
    </>
  );
};

export default TambahDokumen;
